// fetch("https://ccapi.rerrkvifj.com/spot-market-center/klines?symbol=wlfi_usdt&interval=1m&size=1000", {
//   "headers": {
//     "accept": "application/json, text/plain, */*",
//     "accept-language": "en-US",
//     "content-type": "application/json",
//     "ex-browser-name": "Chrome",
//     "ex-browser-version": "141.0.0.0",
//     "ex-client-source": "WEB",
//     "ex-client-type": "WEB",
//     "ex-currency": "USD-%24",
//     "ex-device-id": "P083n5gGfTXdIh3hIWgICMRzQwGdTwy3",
//     "ex-language": "en-US",
//     "ex-language-zh": "%E8%8B%B1%E8%AF%AD",
//     "ex-os-name": "Mac OS",
//     "ex-os-version": "10.15.7",
//     "ex-time-zone": "UTC+7",
//     "ex-timestamp": "1760515028067",
//     "ex-token": "d372ac0b1e1246e38704fa35d6d6858c",
//     "ex-uid": "LBA1G59109",
//     "priority": "u=1, i",
//     "sec-ch-ua": "\"Google Chrome\";v=\"141\", \"Not?A_Brand\";v=\"8\", \"Chromium\";v=\"141\"",
//     "sec-ch-ua-mobile": "?0",
//     "sec-ch-ua-platform": "\"macOS\"",
//     "sec-fetch-dest": "empty",
//     "sec-fetch-mode": "cors",
//     "sec-fetch-site": "cross-site",
//     "sw8-correlationvalue": "traceId:52cf9fa3a4c0e781b1842358e4a0a348.89.17605150280670019,spanId:19,osType:web"
//   },
//   "referrer": "https://www.lbank.com/",
//   "body": null,
//   "method": "GET",
//   "mode": "cors",
//   "credentials": "omit"
// });

// const lbankSpot = () => {
//   return {
//     getKlines: async (symbol, interval, limit) => {
//       const response = await fetch(`https://ccapi.rerrkvifj.com/spot-market-center/klines?symbol=${symbol}&interval=${interval}&size=${limit}`);
//       return response.json();
//     },
//   };
// };

// export default lbankSpot;

// // + веб сокет

// src/hooks/klines/adapters/lbankSpot.js
/* eslint-disable no-console */

const L = (...a) => console.log("[lbank:spot]", ...a);

// ---------- Константы ----------

// если у тебя уже есть локальный прокси, можешь подставить сюда:
// например ""
const DEFAULT_PROXY = `${process.env.REACT_APP_BACKEND_URL}/proxy`; // либо "" чтобы бить напрямую

// продовый REST эндпоинт, который ты приводил
const LBANK_SPOT_REST = "https://ccapi.rerrkvifj.com/spot-market-center/klines";

// WS: адрес может отличаться в зависимости от зоны/доменов LBank.
// Делал параметром, но даю дефолт, который часто работает.
const LBANK_SPOT_WS_URL = "wss://www.lbkex.net/ws/V2/"; // можно заменить через opts.wsUrl

// ---------- Вспомогательное ----------

function withProxy(url, proxyBase = DEFAULT_PROXY) {
  if (!proxyBase) return url;
  // чтобы не было двойных слэшей
  const clean = url.replace(/^https?:\/\//, "");
  return `${proxyBase}/https://${clean}`;
}

function buildHeaders(custom = {}) {
  // Полный набор заголовков как в твоём примере. Можно переопределять через opts.headers.
  return {
    accept: "application/json, text/plain, */*",
    "content-type": "application/json",
    "accept-language": "en-US",
    "ex-browser-name": "Chrome",
    "ex-browser-version": "141.0.0.0",
    "ex-client-source": "WEB",
    "ex-client-type": "WEB",
    "ex-currency": "USD-%24",
    "ex-device-id": "P083n5gGfTXdIh3hIWgICMRzQwGdTwy3",
    "ex-language": "en-US",
    "ex-language-zh": "%E8%8B%B1%E8%AF%AD",
    "ex-os-name": "Mac OS",
    "ex-os-version": "10.15.7",
    "ex-time-zone": "UTC+7",
    "ex-timestamp": String(Date.now()),
    "ex-token": "d372ac0b1e1246e38704fa35d6d6858c",
    "ex-uid": "LBA1G59109",
    priority: "u=1, i",
    "sec-ch-ua": "\"Google Chrome\";v=\"141\", \"Not?A_Brand\";v=\"8\", \"Chromium\";v=\"141\"",
    "sec-ch-ua-mobile": "?0",
    "sec-ch-ua-platform": "\"macOS\"",
    "sec-fetch-dest": "empty",
    "sec-fetch-mode": "cors",
    "sec-fetch-site": "cross-site",
    // trace header из примера не обязателен, но можно добавить:
    // "sw8-correlationvalue": `traceId:${Math.random().toString(16).slice(2)}.89.${Date.now()}0019,spanId:19,osType:web`,
    ...custom,
  };
}

function toNum(v) {
  const n = typeof v === "string" ? Number(v) : +v;
  return Number.isFinite(n) ? n : NaN;
}

function getSpotRoot(resp) {
  // приоритет — data.klines (как в твоём Network-ответе)
  return (
    resp?.data?.klines ??
    resp?.data?.data ??
    resp?.data?.list ??
    resp?.data ??
    resp?.result ??
    resp?.klines ??
    resp
  );
}

function normalizeSpotKlines(resp) {
  const root = getSpotRoot(resp);

  const arr = Array.isArray(root)
    ? root
    : Array.isArray(root?.items)
      ? root.items
      : [];

  if (!Array.isArray(arr)) {
    L("normalizeSpotKlines: not array", resp);
    return [];
  }

  const out = [];
  for (const it of arr) {
    if (Array.isArray(it)) {
      // [t, o, h, l, c, ...] (на всякий)
      const t = toNum(it[0]);
      const o = toNum(it[1]);
      const h = toNum(it[2]);
      const l = toNum(it[3]);
      const c = toNum(it[4]);
      if ([t, o, h, l, c].every(Number.isFinite)) {
        out.push({ time: t > 2e10 ? t : t * 1000, open: o, high: h, low: l, close: c });
      }
      continue;
    }

    // объектный формат: { t, o, h, l, c, ... } — как в твоём JSON
    // запасные поля — на случай других веток API
    const t = toNum(it.t ?? it.BeginTime ?? it.ts ?? it.time ?? it.openTime ?? it.startTime ?? it.timestamp);
    const o = toNum(it.o ?? it.OpenPrice ?? it.open);
    const h = toNum(it.h ?? it.HighestPrice ?? it.high);
    const l = toNum(it.l ?? it.LowestPrice ?? it.low);
    const c = toNum(it.c ?? it.ClosePrice ?? it.close);

    if ([t, o, h, l, c].every(Number.isFinite)) {
      const ms = t > 2e10 ? t : t * 1000; // если сек — в мс
      out.push({ time: ms, open: o, high: h, low: l, close: c });
    }
  }

  // сортировка и dedup по времени
  out.sort((a, b) => a.time - b.time);
  const dedup = [];
  let lastT = -1;
  for (const x of out) {
    if (x.time !== lastT) dedup.push(x);
    lastT = x.time;
  }
  return dedup;
}

// map UI-интервалов → slot для WS
function tfToKbarSlot(tf) {
  switch (tf) {
    case "1m": return "1min";
    case "3m": return "3min";
    case "5m": return "5min";
    case "15m": return "15min";
    case "30m": return "30min";
    case "1h": return "1hr";
    case "2h": return "2hr";
    case "4h": return "4hr";
    case "8h": return "8hr";
    case "12h": return "12hr";
    case "1d": return "day";
    default:   return "1min";
  }
}

// ---------- REST ----------

/**
 * История свечей спота LBank
 * @param {Object} params
 * @param {string} params.symbol - формат "eth_usdt" (нижний регистр + подчёркивание)
 * @param {string} params.interval - "1m" | "5m" | "15m" | ... (REST ест такие же, без конвертации)
 * @param {number} [params.limit=300] - size
 * @param {Object} [params.headers] - переопределить заголовки
 * @param {string} [params.proxyBase] - прокси-база (например )
 */
export async function lbankSpotFetchHistory({
  symbol,
  interval,
  limit = 300,
  headers,
  proxyBase,
} = {}) {
  const url = `${LBANK_SPOT_REST}?symbol=${encodeURIComponent(symbol)}&interval=${encodeURIComponent(interval)}&size=${limit}`;
  const finalUrl = withProxy(url, proxyBase);
  const hdrs = buildHeaders(headers);

  L("REST fetch", { symbol, interval, limit, url: finalUrl, headers: hdrs });

  const resp = await fetch(finalUrl, {
    method: "GET",
    mode: proxyBase ? "cors" : "cors",
    credentials: "omit",
    headers: hdrs,
    referrer: "https://www.lbank.com/",
    headers: { 'ngrok-skip-browser-warning': '1' },
  });

  if (!resp.ok) {
    throw new Error(`LBank SPOT HTTP ${resp.status}`);
  }

  const json = await resp.json().catch(() => ({}));
  L("raw response", json);

  const candles = normalizeSpotKlines(json);
  L("done", { symbol, interval, count: candles.length, first: candles[0], last: candles[candles.length - 1] });

  return candles;
}

// ---------- WS ----------

/**
 * Реальный WebSocket подписка на kbar (спот)
 * @param {Object} params
 * @param {string} params.symbol - "eth_btc" / "eth_usdt" (нижний регистр + "_")
 * @param {string} params.interval - UI формат ("1m","5m","15m","30m","1h","4h","1d"...)
 * @param {(candle: {time:number,open:number,high:number,low:number,close:number}) => void} params.onCandle
 * @param {string} [params.wsUrl] - переопределить WS url (по умолчанию LBANK_SPOT_WS_URL)
 */
export function lbankSpotOpenWS({ symbol, interval = "1m", onCandle, wsUrl } = {}) {
  const url = wsUrl || LBANK_SPOT_WS_URL;
  const slot = tfToKbarSlot(interval);

  L("WS open", { url, symbol, interval, slot });

  const ws = new WebSocket(url);
  let subscribed = false;

  const send = (obj) => {
    try {
      ws.send(JSON.stringify(obj));
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn("[lbank:spot] ws send error", e?.message || e);
    }
  };

  const close = () => {
    try {
      if (subscribed && ws.readyState === WebSocket.OPEN) {
        send({
          action: "unsubscribe",
          subscribe: "kbar",
          kbar: slot,
          pair: symbol,
        });
        L("WS unsubscribe", { symbol, slot });
      }
    } catch {}
    try { ws.close(); } catch {}
    L("WS closed");
  };

  ws.onopen = () => {
    subscribed = true;
    send({
      action: "subscribe",
      subscribe: "kbar",
      kbar: slot,
      pair: symbol, // ВАЖНО: нижний регистр + "_"
    });
    L("WS subscribed", { symbol, slot });
  };

  ws.onmessage = (evt) => {
    try {
      const msg = JSON.parse(evt.data);
      if (msg?.type !== "kbar") return;
      const k = msg.kbar || {};
      // пример:
      // k = { a, c, t: "2019-06-28T17:45:00.000", v, h, slot:"5min", l, n, o }
      const tRaw = k.t;
      let t = NaN;
      if (typeof tRaw === "string") {
        const d = Date.parse(tRaw);
        if (Number.isFinite(d)) t = d; // уже ms
      } else {
        t = toNum(tRaw);
        if (Number.isFinite(t) && t < 2e10) t = t * 1000; // если в секундах
      }

      const o = toNum(k.o);
      const h = toNum(k.h);
      const l = toNum(k.l);
      const c = toNum(k.c);

      if ([t, o, h, l, c].every(Number.isFinite)) {
        onCandle?.({ time: t, open: o, high: h, low: l, close: c });
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn("[lbank:spot] WS parse error", e?.message || e);
    }
  };

  ws.onerror = (e) => console.warn("[lbank:spot] WS error", e);
  ws.onclose = () => L("WS onclose");

  return close;
}

// ---------- экспорт по умолчанию ----------
export default {
  lbankSpotFetchHistory,
  lbankSpotOpenWS,
};
